
import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'

import { useProgrammation } from '../../../Hooks/UseProgrammation'
import useTranslation from '../../../Hooks/UseTranslation'

import './TaskStatus.scss'

const TaskStatus = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  const types: any = {
    'activa': { label: t('PROGRAMMATION_MANAGER:StatusActive') },
    'activa-atrasada': { label: t('PROGRAMMATION_MANAGER:StatusActiveOverdue') },
    'liberada': { label: t('PROGRAMMATION_MANAGER:StatusReleased') },
    'atrasada': { label: t('PROGRAMMATION_MANAGER:StatusOverdue') },
    'pendiente': { label: t('PROGRAMMATION_MANAGER:StatusPending') },
    'completada': { label: t('PROGRAMMATION_MANAGER:StatusCompleted') },
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:StatusLabel')}
      </Form.Label>
      <div className='task-status'>
        {(itemOpened.progress < 100 || itemOpened.confirmed) && (
          <Fragment>
            <div className={`status-color ${itemOpened.status}`} />
            {types[itemOpened.status].label}
          </Fragment>
        )}
        {itemOpened.progress === 100 && !itemOpened.confirmed && (
          <Fragment>
            <div className={`status-color pending-confirmation`} />
            {t('PROGRAMMATION_MANAGER:StatusPendingConfirmation')}
          </Fragment>
        )}
      </div>
    </Form.Group>
  )
}

export default TaskStatus
